/*
 * Configuration
 */

export const COMAP_URL = 'https://comap.sasaki.com/msu/';

export const GA_ID = 'G-KWKTZ4TY89';

export const HEAP_ID = '2076391022';

export const FORMSPREE_URL = 'https://formspree.io/f/mzboajzq';

export const MOBILE_BREAKPOINT = 1200;

export const MENU = [
    { text: 'Welcome', href: '#welcome' },
    { text: 'Vision', href: '#vision' },
    { text: 'Process', href: '#process' },
    { text: 'Updates', href: '#resources' },
    { text: 'Share Your Ideas', href: '#contact' },
];
